import React, { useMemo, useState } from "react";
import { Button, Form, Input, Modal } from "antd";

interface DeleteTemplateConfirmModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function DeleteTemplateConfirmModal(props: DeleteTemplateConfirmModalProps) {
  const [form] = Form.useForm();

  const [inputValue, setInputValue] = useState("");

  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };

  const DeleteTemplateConfirmModalContent = useMemo(() => {
    const onFinish = (value: any) => {
      props.close();
      form.resetFields();
    };
    return (
      <div className="d-flex flex-column gap-4 w-100 modal-body-content">
        <h4>Delete Template</h4>
        <p>
          Please enter <strong>"permanently delete"</strong> to confirm the deletion of template:<strong></strong>
        </p>
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical">
          <Form.Item
            name="confirmation"
            rules={[{ required: true, message: "Please type 'permanently delete' to proceed." }]}>
            <Input
              placeholder="permanently delete"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <Button onClick={handleModalClose}>Cancel</Button>
            <Button
              type="primary"
              danger
              htmlType="submit"
              disabled={inputValue !== "permanently delete"}>
              Delete
            </Button>
          </div>
        </Form>
      </div>
    );
  }, []);

  return (
    <div>
      <Modal
        zIndex={1500}
        footer={[]}
        width={500}
        onCancel={handleModalClose}
        open={props.openState}>
        {DeleteTemplateConfirmModalContent}
      </Modal>
    </div>
  );
}

export default DeleteTemplateConfirmModal;
